//
//
//
//
//
//

export default {
  name: 'Qc',
  props: {
    fixed: {
      type: Boolean,
      default: false,
    }
  },
  data() {
    return {
      height: 0
    }
  },
  mounted() {
    this.height = this.$refs.qc.offsetHeight;
  },
  methods: {
    jumpPage() {
      location.href = 'http://m.wego168.com/m/index.html?from=abs'
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/Qc.vue